import { useState } from "react";
import { useNavigate } from "react-router";
import { api } from "~/api/client";
import { OperioBrand } from "~/ui/brand/OperioBrand";

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      await api.post("/auth/request-password-reset", { email });
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Fehler beim Senden.");
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
        <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-md">
          <div className="mb-4 text-5xl">📧</div>
          <h2 className="mb-2 text-2xl font-bold text-gray-900">
            E-Mail gesendet
          </h2>
          <p className="mb-6 text-gray-600">
            Falls ein Konto mit dieser E-Mail existiert, erhältst du in Kürze
            einen Link.
          </p>
          <button
            onClick={() => navigate("/login")}
            className="text-blue-600 hover:text-blue-700"
          >
            ← Zurück zum Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <div className="mb-6"><OperioBrand centered /></div>
        <h1 className="mb-2 text-center text-2xl font-bold text-gray-900">
          Passwort vergessen
        </h1>
        <p className="mb-6 text-center text-sm text-gray-600">
          Gib deine E-Mail-Adresse ein. Du erhältst einen Link zum Zurücksetzen
          (gültig 1 Stunde).
        </p>

        {error && (
          <div className="mb-4 rounded-md bg-red-50 p-4 text-sm text-red-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              E-Mail
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-blue-500 focus:outline-none"
              placeholder="name@example.com"
            />
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-md bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {isLoading ? "Wird gesendet..." : "Reset-Link senden"}
          </button>
        </form>

        <p className="mt-4 text-center text-sm">
          <button
            onClick={() => navigate("/login")}
            className="text-blue-600 hover:text-blue-700"
          >
            ← Zurück zum Login
          </button>
        </p>
      </div>
    </div>
  );
}
